const downloadBtn = document.querySelectorAll('.download')

if(downloadBtn) {
	downloadBtn.forEach(btn => {
		btn.addEventListener('click', e => {
			
			if(e.target.parentElement.parentElement) {
				const list = e.target.parentElement.parentElement
				const listLinks = list.querySelectorAll('a')
				
				listLinks.forEach(listItem => {
					listItem.click()
				})
			}
		})
	})
}